import { tokens } from '@welbe/web-design-system';
import styled, { css } from 'styled-components';

type CertifiedProps = { certified?: boolean };

export const Container = styled.div<CertifiedProps>`
	display: flex;
	align-items: center;

	& > svg {
		margin-right: 8px;
	}

	& > svg > g > path {
		fill: ${({ certified }) =>
			certified ? tokens.color_primary : tokens.color_gray_medium};
	}
`;

export const AnchorLink = styled.a<CertifiedProps>`
	${({ certified }) =>
		certified
			? css`
					text-decoration: underline;
					cursor: pointer;
					color: ${tokens.color_primary};

					&:hover {
						color: #5082c2b0;
					}
			  `
			: css`
					text-decoration: none;
					cursor: not-allowed;
					color: ${tokens.color_gray_medium};
			  `}
`;
